/** 오류 한 줄에 결과를 올리는 쓰기 요청 — 쓰기 훅의 결과가 이 모양을 갖는다. */
export interface ResettableRequest {
  readonly isPending: boolean;
  /** 지난 오류를 지운다. */
  readonly reset: () => void;
}

/**
 * 같은 오류 줄을 쓰는 요청들의 지난 오류를 지운다 — 새 요청을 보내기 직전에 부른다.
 *
 * 진행 중인 요청은 건드리지 않는다. TanStack Query 의 reset 은 진행 중인 요청을 화면에서 떼어 내서,
 * 그 요청이 실패해도 사유가 화면에 나오지 않고 진행 중 잠금(isPending)도 요청이 끝나기 전에 풀린다.
 * 진행 중인 요청은 아직 오류가 없으니 지울 것도 없다.
 */
export const resetSettledRequests = (requests: readonly ResettableRequest[]): void => {
  for (const request of requests) {
    if (!request.isPending) {
      request.reset();
    }
  }
};
